export default {
    methods: {
        getGraphicSourceSize(source) {
            if (!source || typeof source !== 'string' || source === 'Image') {
                return null;
            }

            const widthAttr = source.match(/\bwidth=["']([\d.]+)(?:px)?["']/i);
            const heightAttr = source.match(/\bheight=["']([\d.]+)(?:px)?["']/i);
            if (widthAttr && heightAttr) {
                const width = parseFloat(widthAttr[1]);
                const height = parseFloat(heightAttr[1]);
                if (width > 0 && height > 0) {
                    return { width, height };
                }
            }

            const vb = source.match(/\bviewBox=["']([^"']+)["']/i);
            if (vb) {
                const parts = vb[1].trim().split(/[\s,]+/);
                if (parts.length === 4) {
                    const width = parseFloat(parts[2]);
                    const height = parseFloat(parts[3]);
                    if (width > 0 && height > 0) {
                        return { width, height };
                    }
                }
            }

            return null;
        },
        getObjectDisplaySize(obj) {
            if (!obj) {
                return null;
            }

            const scale = parseFloat(obj.scale);
            const safeScale = Number.isFinite(scale) && scale > 0 ? scale : 1;

            if (obj.dimensions && parseFloat(obj.dimensions.width) > 0 && parseFloat(obj.dimensions.height) > 0) {
                return {
                    width: parseFloat(obj.dimensions.width) * safeScale,
                    height: parseFloat(obj.dimensions.height) * safeScale
                };
            }

            const sourceSize = this.getGraphicSourceSize(obj.source);
            if (sourceSize) {
                return {
                    width: sourceSize.width * safeScale,
                    height: sourceSize.height * safeScale
                };
            }

            return null;
        },
        applySvgPresentation(source, width, height, style) {
            const svgOpen = source.match(/<svg\b[^>]*>/i);
            if (!svgOpen) {
                return source;
            }

            let tag = svgOpen[0];
            tag = tag.replace(/\s(width|height)=["'][^"']*["']/gi, '');

            const existingStyle = tag.match(/\sstyle=["']([^"']*)["']/i);
            let nextStyle = style || '';
            if (existingStyle) {
                const prev = existingStyle[1].replace(/;?\s*$/, '');
                nextStyle = [prev, style].filter(Boolean).join('; ');
                tag = tag.replace(/\sstyle=["'][^"']*["']/i, '');
            }

            const isSelfClosing = /\/\s*>$/.test(tag);
            tag = tag.replace(/\s*\/?>\s*$/, '');
            tag += ` width="${width}" height="${height}" style="${nextStyle}"`;
            tag += isSelfClosing ? '/>' : '>';

            return source.slice(0, svgOpen.index) + tag + source.slice(svgOpen.index + svgOpen[0].length);
        },
        renderSvgObjectHtml(obj, extraStyle) {
            if (!obj || !obj.source || obj.source === 'Image') {
                return '';
            }

            let source = obj.source;
            const scale = parseFloat(obj.scale);
            const safeScale = Number.isFinite(scale) && scale > 0 ? scale : 1;
            const size = this.getObjectDisplaySize(obj) || {
                width: 100 * safeScale,
                height: 100 * safeScale
            };

            source = source.replace(/fill="black"/g, `fill="${obj.color}"`);
            source = source.replace(/stroke="black"/g, `stroke="${obj.color}"`);

            const style = [
                `opacity: ${obj.alpha}`,
                extraStyle || '',
                `transform: rotate(${obj.angle || 0}deg)`,
                `z-index: ${obj.z_index}`,
                'display: block'
            ].filter(Boolean).join('; ');

            return this.applySvgPresentation(source, size.width, size.height, style);
        },
        getObjectAnchorSize(obj, el) {
            const size = this.getObjectDisplaySize(obj);
            if (size && size.width > 0 && size.height > 0) {
                return size;
            }

            return {
                width: el ? el.clientWidth : 0,
                height: el ? el.clientHeight : 0
            };
        },
        syncObjectModelFromElement(index) {
            const obj = this.template && this.template.objects && this.template.objects[index];
            const el = this.$refs.draggableContainer2 && this.$refs.draggableContainer2[index];
            if (!obj || !el) {
                return;
            }

            const size = this.getObjectAnchorSize(obj, el);
            const centerX = el.offsetLeft + size.width / 2;
            const centerY = el.offsetTop + size.height / 2;
            obj.position_x = parseFloat((centerX / 360).toFixed(4));
            obj.position_y = parseFloat((centerY / (this.heightCanvas || 640)).toFixed(4));
        },
        applyAllObjectContainerPositions() {
            const objects = this.template && this.template.objects;
            if (!objects) {
                return;
            }

            for (let i = 0; i < objects.length; i++) {
                this.applyObjectContainerPosition(i);
            }
        },
        applyObjectContainerPosition(index, retry = 0) {
            const obj = this.template && this.template.objects && this.template.objects[index];
            const containers = this.$refs.draggableContainer2;
            if (!obj) {
                return;
            }

            if (!containers || !containers[index]) {
                if (retry < 20) {
                    setTimeout(() => this.applyObjectContainerPosition(index, retry + 1), 50);
                }
                return;
            }

            const el = containers[index];
            const size = this.getObjectAnchorSize(obj, el);
            const width = size.width;
            const height = size.height;

            if ((!size || width < 1 || height < 1) && el.clientHeight < 1 && retry < 20) {
                const img = el.querySelector('img');
                if (img && !img.complete) {
                    img.onload = () => this.$nextTick(() => this.applyObjectContainerPosition(index, retry + 1));
                    img.onerror = () => this.$nextTick(() => this.applyObjectContainerPosition(index, retry + 1));
                    return;
                }

                setTimeout(() => this.applyObjectContainerPosition(index, retry + 1), 50);
                return;
            }

            const canvasHeight = this.heightCanvas || 640;
            el.style.left = (parseFloat(obj.position_x) * 360 - width / 2) + 'px';
            el.style.top = (parseFloat(obj.position_y) * canvasHeight - height / 2) + 'px';
        },
        applyReplacedObjectSize(obj, newWidth, newHeight, setDimensions) {
            const scale = parseFloat(obj.scale) || 1;
            let prevW = 0;
            let prevH = 0;

            if (obj.dimensions && parseFloat(obj.dimensions.width) > 0 && parseFloat(obj.dimensions.height) > 0) {
                prevW = parseFloat(obj.dimensions.width) * scale;
                prevH = parseFloat(obj.dimensions.height) * scale;
            } else {
                const sourceSize = this.getGraphicSourceSize(obj.source);
                if (sourceSize) {
                    prevW = sourceSize.width * scale;
                    prevH = sourceSize.height * scale;
                }
            }

            newWidth = parseFloat(newWidth);
            newHeight = parseFloat(newHeight);

            if (setDimensions && newWidth > 0 && newHeight > 0) {
                this.$set(obj, 'dimensions', {
                    width: newWidth,
                    height: newHeight
                });
            }

            if (prevW > 0 && prevH > 0 && newWidth > 0 && newHeight > 0) {
                const nextScale = Math.min(prevW / newWidth, prevH / newHeight);
                if (Number.isFinite(nextScale) && nextScale > 0) {
                    obj.scale = parseFloat(nextScale.toFixed(4));
                }
            }
        },
        syncReplacedObjectPosition() {
            this.$nextTick(() => {
                this.applyObjectContainerPosition(this.active_object);
            });
        },
        replaceActiveGraphic(object, source, newWidth, newHeight, setDimensions) {
            const obj = this.template.objects[this.active_object];
            if (!obj) {
                return;
            }

            this.applyReplacedObjectSize(obj, newWidth, newHeight, setDimensions);
            obj.id = object.src;
            obj.source = source;
            this.syncReplacedObjectPosition();
            if (typeof this.ensureFrozenGif === 'function') {
                this.ensureFrozenGif(object.src);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/replaceGraphicSize.js